import { createContext, useContext } from "react";

interface HistoryContextProps {
  history: string[];
}

const HistoryContext = createContext<HistoryContextProps | undefined>(undefined);

export const useHistory = (): HistoryContextProps => {
  const context = useContext(HistoryContext);
  if (!context) {
    throw new Error("'useHistory' must be used within a History Provider");
  }
  return context;
};

export { HistoryContext };
